// @ vendor
 import React from 'react'
const { renderToStaticMarkup } = require('react-dom/server')
const storage = require('utilities/storage');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { Provider } = require('react-redux');
const { Router } = require('react-router-dom');
const { store, history } = require('../../../../../store/configureStore');

const printGenericDocument = (component) => {
    if (isPrintOfficeMode()) {
        let item = (
            <Provider store={store}>
                <Router history={history}>
                    {component}
                </Router>
            </Provider>
        );
        let html = renderToStaticMarkup(item);
        storage.localStorage.set('printableParametersContent', html);
    }
}

module.exports = printGenericDocument;
